var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSproutAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4319 3.77982C11.6444 3.9854 11.8329 4.20689 12 4.43951C12.1671 4.20689 12.3556 3.9854 12.5681 3.77982C14.1081 2.29001 16.5134 2.02037 17.893 2.00013C18.5229 1.9909 19.0092 2.46105 18.9999 3.07014C18.9794 4.4043 18.7014 6.73036 17.1613 8.22018C15.9964 9.34703 14.3366 9.77582 13 9.92663V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V9.92663C9.66339 9.77582 8.00356 9.34703 6.83869 8.22018C5.29862 6.73036 5.02059 4.4043 5.00013 3.07014C4.99079 2.46105 5.47713 1.9909 6.10698 2.00013C7.48661 2.02037 9.89185 2.29001 11.4319 3.77982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSproutAlt1);
export default __webpack_public_path__ + "static/media/sprout-alt-1.2121e6fb7998cf761d550fb6395deb1f.svg";
export { ForwardRef as ReactComponent };